import { Box, type BoxProps } from "@hightouch/htui";
import type { ElementType } from "react";

// Sizes a UI-library icon to the nav's icon size (20px) for the `icon` prop.
export const navIcon = (Icon: ElementType) => {
  const NavIcon = (props: BoxProps) => <Box as={Icon} boxSize={5} {...props} />;
  return NavIcon;
};
